import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { useState, useEffect } from "react";
import Table from "../Table";
import { useHistory } from "react-router-dom";

const UnpublishedFaq = ({
  heading = " ",
  tableData = [],
  tableHeading = [],
  sizePerPage,
  publishBlog,
  buttonName,
  handleTablePageChange,
  page,
  totalSize,
}) => {
  const [rowData, setRowData] = useState([]);
  const history = useHistory();

  const handleEditUserClick = (userId) => {
    history.push("/dashboard/faq/editfaq/" + userId);
  };

  const actionsFormatter = (cell, row) => {
    return (
      <div style={{ textAlign: "center" }} key={row._id}>
        <i
          className="ri-file-edit-fill text-info h4 cursor-pointer mr-2"
          onClick={() => {
            
            handleEditUserClick(row._id)
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    tableHeading.push({
      text: "Actions",
      dataField: "actions",
      isDummyField: true,
      headerStyle: { textAlign: "center", width: "10%" },
      formatter: actionsFormatter,
    });

    tableHeading.push({
      text: "Publish FAQ",
      dataField: "publish",
      isDummyField: true,
      headerStyle: { textAlign: "center", width: "10%" },
      formatter: unpublishFormatter,
    });
    return () => {
      tableHeading.pop();

      tableHeading.pop();
    };
    // eslint-disable-next-line
  }, []);

  const unpublishFormatter = (cell, row) => {
    return (
      <div style={{ textAlign: "center" }} key={row._id}>
        <Button
          color="success"
          className="waves-effect waves-light"
          style={{ width: "100%" }}
          onClick={() => {
            publishBlog(row._id);
          }}
        >
          {buttonName}
        </Button>
      </div>
    );
  };
  useEffect(() => {
    if (tableData) {
      var result = tableData.map((el, i) => {
        var o = Object.assign({ ...el });
        o.sNo = i + 1 + page * 10 - 10;
        return o;
      });

      setRowData(result);
    }
    // eslint-disable-next-line
  }, [tableData]);
  
  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h3 className="m-0">{heading}</h3>
                  </div>
                </Col>
              </Row>
              <Table
                rows={rowData}
                columns={tableHeading}
                onTableChange={handleTablePageChange}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={totalSize}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default UnpublishedFaq;
